import request from '@/utils/request'

export function pageLiveCourseCategory(data) {
  return request({ url: '/livecourse/category/page', method: 'post', data })
}

export function listLiveCourseCategory() {
  return request({ url: '/livecourse/category/list', method: 'get' })
}

export function addLiveCourseCategory(data) {
  return request({ url: '/livecourse/category/add', method: 'post', data })
}

export function editLiveCourseCategory(data) {
  return request({ url: '/livecourse/category/edit', method: 'post', data })
}

export function deleteLiveCourseCategory(id) {
  return request({ url: '/livecourse/category/delete', method: 'post', params: { id } })
}
